import { useTranslation } from "react-i18next";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import GaiaDataGrid from "~/modules/app/components/GaiaTable";

import { FunctionTypeObservationTypeDataGridFragment } from "./fragments.generated";

type Props = {
    functionTypeObservationTypes: FunctionTypeObservationTypeDataGridFragment[];
    isAdmin: boolean;
    onDeleteClick: (observationTypeId: string) => Promise<void>;
    isLoading: boolean;
};

export default function FunctionTypeObservationTypeDataGrid({
    functionTypeObservationTypes,
    isAdmin,
    onDeleteClick,
    isLoading,
}: Props) {
    const { t } = useTranslation("functionType");

    return (
        <GaiaDataGrid
            rows={functionTypeObservationTypes}
            columns={[
                {
                    field: "name",
                    headerName: t("functionTypeObservationTypeDataGrid.headerName"),
                    flex: 1,
                },
                ...(isAdmin
                    ? [
                          {
                              type: "actions" as const,
                              field: "actions",
                              headerName: t("functionTypeObservationTypeDataGrid.headerDelete"),
                              flex: 1,
                              renderCell: (params: { row: { id: string } }) => (
                                  <GaiaDeleteButton
                                      isLoading={isLoading}
                                      onDelete={() => onDeleteClick(params.row.id)}
                                  />
                              ),
                          },
                      ]
                    : []),
            ]}
            loading={isLoading}
            rowCount={functionTypeObservationTypes.length}
        />
    );
}
